import Button from "components/CustomButtons/Button";
import { LoginContext } from "contexts/LoginContext";
import { useContext, useMemo, useState } from "react";
import AssignCourseToStudents from "./AssignCourseToStudents";
import AssignTestToStudents from "./AssignTestToStudents";
import CourseCreationSteps from "./CourseCreationSteps";
import StudentsOnBoardingSteps from "./StudentsOnBoardingSteps";
import TestCreationSteps from "./TestCreationSteps";

function TrialUserAlertPage({ setShowTrialInfo, setShowTrialAlert }) {
    const { providerValidTo } = useContext(LoginContext);
    const [steps, setSteps] = useState(1);

    const remainingDays = useMemo(() => {
        console.log(providerValidTo, typeof (providerValidTo), 'validity')
        if (!providerValidTo) return null;
        const expiryDate = new Date(providerValidTo);
        const today = new Date();
        const diffTime = expiryDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert ms to days
        console.log(diffDays, 'diffdays')
        return diffDays;
    }, [providerValidTo]);

    return (
        <div
            style={{
                overflowX: "auto",
                padding: "20px",
                fontFamily: "Arial, sans-serif",
                color: "#333"
            }}
        >
            {
                steps === 1 && (
                    <div>
                        {/* <h3 style={{ color: "#ff9800" }}>⚠️ Trial Period Notice</h3> */}
                        <p>
                            You are currently using a <strong>trial version</strong> of <strong>learningFitbit</strong>.
                            This version provides limited access to features and will expire in <strong>{remainingDays} {remainingDays === 1 ? "day" : "days"}</strong>.
                        </p>
                        <p>
                            To continue using the platform without interruption and unlock full functionality, please consider upgrading to a plan.
                        </p>
                        <p>
                            For questions, contact us at <a href="mailto:technology@splayndid.com">technology@splayndid.com</a>.
                        </p>
                        <p>Thank you for trying <strong>learningFitbit</strong>!</p>
                    </div>
                )
            }
            {
                steps === 2 && (
                    <StudentsOnBoardingSteps />
                )
            }
            {
                steps === 3 && (
                    <TestCreationSteps />
                )
            }
            {
                steps === 4 && (
                    <AssignTestToStudents />
                )
            }
            {
                steps === 5 && (
                    <CourseCreationSteps />
                )
            }
            {
                steps === 6 && (
                    <AssignCourseToStudents />
                )
            }

            <div style={{ textAlign: "right", marginTop: "20px" }}>
                <Button
                    color="primary"
                    onClick={() => {
                        setShowTrialInfo(null);
                        setShowTrialAlert(false);
                    }}
                    style={{ textTransform: "none", marginInline: '10px' }}
                >
                    {
                        steps === 6 ? 'Finish' : 'Skip'
                    }
                </Button>
                <Button
                    color="primary"
                    onClick={() => setSteps(steps + 1)}
                    style={{ textTransform: "none" }}
                    disabled={steps === 6}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}

export default TrialUserAlertPage;
